module.exports = __webpack_public_path__ + "img/рз_1.c68259ea.png";